import {getCheckoutOrderManager, getCurrentCurrency} from 'cart-ui';
import fbq from './fbq';

export default function enablePurchaseTracking() {
    const data: {orderMgr?} = {};
    getCheckoutOrderManager().then((orderMgr) => {
        data.orderMgr = orderMgr;
        data.orderMgr.getEventManager().on(
            'orderMgr.processNonCurrentOrder.success.sendThirdPartyAnalytics',
            async (response) => {
                try {
                    const currency = await getCurrentCurrency();
                    const order = response.data;
                    fbq('track', 'Purchase', {
                        content_type: 'product',
                        contents: order.items.map(function (item) {
                            return {
                                id: item.skuNumber,
                                item_price: item.price,
                                quantity: item.qty,
                            };
                        }),
                        currency,
                        value: order.orderTotals.total,
                    });
                } catch {
                    throw new Error('facebookAnalytics');
                }
            }
        );
    });
}
